import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../common/helpers/formatDate";

// The range picked on one POS report carries over to the others for the rest of the tab's
// session (sessionStorage: survives refresh, cleared when the tab closes, separate per tab).
const STORAGE_KEY = "pos-report-date-range";

const readSavedRange = () => {
    try {
        const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
        const start = saved?.start ? new Date(saved.start) : null;
        const end = saved?.end ? new Date(saved.end) : null;
        if (!start || !end || isNaN(start) || isNaN(end)) return null;
        return { start, end };
    } catch (err) {
        return null;
    }
};

// Called when the POS voucher changes and when leaving POS, so reports start from today again.
export const clearSavedReportDateRange = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {
        // Storage unavailable: nothing was saved.
    }
};

const saveRange = (start, end) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ start: start.toISOString(), end: end.toISOString() }));
    } catch (err) {
        // Storage unavailable (e.g. private mode): the range just doesn't carry over.
    }
};

export const Daterangepos = (props) => {
    const { setDatefilter } = props
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [savedRange] = useState(readSavedRange);
    const [startDate, setStartDate] = useState();
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);

    const [endDate, setEndDate] = useState(savedRange ? savedRange.end : currentDate);
    const datePickerRef = useRef(null);
    const changedate = (update) => {
        if (update[1] === null) {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            // One click already applies "start → now" to the report, so remember it as well;
            // a second click (end date) then overwrites it with the full range.
            const now = new Date();
            setStartDate(startOfDay);
            setEndDate(update[1])
            setDatefilter([startOfDay, now]);
            if (startOfDay) saveRange(startOfDay, now);
        } else {
            const startOfDay = update[0]
                ? new Date(update[0].setHours(12, 10, 10, 999))
                : null;
            const endOfDay = update[1]
                ? new Date(update[1].setHours(23, 59, 59, 999))
                : null;
            setStartDate(startOfDay);
            setEndDate(endOfDay)
            setDatefilter([startOfDay, endOfDay]);
            if (startOfDay && endOfDay) saveRange(startOfDay, endOfDay);
        }
    }

    useEffect(() => {
        if (savedRange) {
            setStartDate(savedRange.start);
            setDatefilter([savedRange.start, savedRange.end]);
            return;
        }
        const prevMonth = new Date();
        // prevMonth.setMonth(prevMonth.getMonth() - 1);
        setStartDate(prevMonth);
        setDatefilter([prevMonth, endDate]);
        // eslint-disable-next-line
    }, []);
    return (
        <React.Fragment>


            <div className="dateranger position-relative" >
                <div className=" main-body-top-status-bar-multi-date-picker-wrap " onClick={() => datePickerRef.current.setOpen(true)}>
                    <input type="text" value={startDate ? formatDate(startDate) : "DD/MM/YYYY"} placeholder="start-date" readOnly />
                    <span className="date-arrow">
                        <img
                            src={base_assets + "images/icons/calendar_arrow.svg"}
                            className="calendar_arrow" alt=""
                        />
                    </span>
                    <input type="text" value={endDate ? formatDate(endDate) : formatDate(new Date())} placeholder="end-date" readOnly />
                    <span className="main-body-top-status-bar-multi-date-picker-wrap-calender">
                        <img
                            src={base_assets + "images/icons/calendar-green.svg"}
                            alt=""
                        />
                    </span>
                </div>
                <DatePicker
                    selectsRange={true}
                    monthsShown={2}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        changedate(update);
                    }}
                    dateFormat="yyyy-MM-dd"
                    className='d-flex'
                    ref={datePickerRef}
                    showMonthDropdown="true"
                    showYearDropdown="true"
                    autoComplete='none'
                />
            </div>

        </React.Fragment>
    );

}